<div class="container-fluid">
  <div class="row d-flex align-items-center">
    <!-- Left Section: Dropdown and Info Icon -->
    <div class="col-md-3 d-flex align-items-center justify-content-start">
      <select class="form-control custom-select" (change)="onMachineChange($event)" name="machineName" id="machineName"
        [(ngModel)]="selectedMachine">
        <option *ngFor="let device of machine_List" [value]="device.deviceName">
          {{ device.deviceName }}
        </option>
      </select>
      <i *ngIf="showData" (click)="openModal(shifttemplate)" class="ri-information-fill font-size-14"
        style="cursor: pointer; margin-left: 5px"></i>
    </div>
    <div class="col-md-3 d-flex align-items-center justify-content-start">
    </div>

    <!-- Middle Section: Status and Time -->
    <div class="col-md-4 d-flex align-items-center justify-content-end">
      <div *ngIf="showData" class="spinner-grow" role="status" [style.color]="statusColor(status)">
        <span class="sr-only">Loading...</span>
      </div>
      <h6 class="status ml-1" [style.color]="statusColor(status)">
        {{ currentStatus }}
      <span *ngIf="interlockData && interlockData.length > 0"
            class="interlock-box"
            title="Interlock Release"
            (click)="openInterlockModal()">
        <i class="mdi mdi-alert"></i>
      </span>
      </h6>
      <h6 *ngIf="showData" class="ml-1">| {{ epochToHHMMSS(LUT) }}</h6>
    </div>

    <!-- Right Section: Refresh Button and Date Picker -->
    <div class="col-md-2 d-flex align-items-center justify-content-end">
      <button class="btn btn-primary" type="button" (click)="refreshData()">
        <i class="fas fa-sync sync-icon"></i>
      </button>
      <input [disabled]="!addRecord" type="date" class="form-control ml-2" [max]="maxDate" [min]="minDate"
        [(ngModel)]="startDate" placeholder="From Date" name="startDate" id="startDate"
        (ngModelChange)="select_Date($event)" />
    </div>
  </div>

  <div *ngIf="showData">
    <div class="row mt-1" *ngIf="role !== 'SUPERVISOR'">
     <div [ngClass]="role !== 'SUPERADMIN' ? (isMiltiselection ? 'col-md-9' : 'col-md-12') : 'col-md-12'">
        <div class="card">
          <div class="card-body">
            <div class="media">
              <div class="media-body overflow-hidden">
                <div class="row">
                  <div class="col-md-12 text-center">

                      <!-- <div class="row"> -->
                        <!-- Mobile View: Efficiency and Utilization -->
                        <!-- <div class="col-12 mb-3 d-flex d-md-none justify-content-between flex-wrap">
                          <div class="flex-fill text-center">
                            <h6 class="text-primary">M-Efficiency</h6>
                            <h5 class="mb-0">
                              {{ m_effic ? m_effic : 0 }}
                              <span style="font-size: 1rem !important">% </span>
                            </h5>
                          </div>
                          <div class="flex-fill text-center">
                            <h6 class="text-primary">M-Performance</h6>
                            <h5 class="mb-0">
                              {{ perf ? perf : 0 }}
                              <span style="font-size: 1rem !important">% </span>
                            </h5>
                          </div>
                        </div> -->

                        <!-- Desktop View: Efficiency and Utilization -->
                        <!-- <div class="col-12 col-md-2 d-none d-md-flex flex-column align-items-center">
                          <h6 class="text-primary">M-Efficiency</h6>
                          <h5 class="mb-0">
                            {{ m_effic ? m_effic : 0 }}
                            <span style="font-size: 1rem !important">% </span>
                          </h5>
                        </div>
                        <div class="col-12 col-md-2 d-none d-md-flex flex-column align-items-center">
                          <h6 class="text-primary">M-Performance</h6>
                          <h5 class="mb-0">
                            {{ perf ? perf : 0 }}
                            <span style="font-size: 1rem !important">% </span>
                          </h5>
                        </div> -->

                        <!-- Mobile View: Running and Idle -->
                        <!-- <div class="col-12 mb-3 d-flex d-md-none justify-content-between flex-wrap">
                          <div class="flex-fill text-center">
                            <h6 class="text-primary">Running</h6>
                            <h5 class="mb-0">{{ convertDuration(pierunning_response) }}</h5>
                          </div>
                          <div class="flex-fill text-center">
                            <h6 class="text-primary">Idle</h6>
                            <h5 class="mb-0">{{ convertDuration(pieidle_response) }}</h5>
                          </div>
                        </div> -->

                        <!-- Desktop View: Running and Idle -->
                        <!-- <div class="col-12 col-md-2 d-none d-md-flex flex-column align-items-center">
                          <h6 class="text-primary">Running</h6>
                          <h5 class="mb-0">{{ convertDuration(pierunning_response) }}</h5>
                        </div>
                        <div class="col-12 col-md-2 d-none d-md-flex flex-column align-items-center">
                          <h6 class="text-primary">Idle</h6>
                          <h5 class="mb-0">{{ convertDuration(pieidle_response) }}</h5>
                        </div> -->

                        <!-- Mobile View: Total Parts and Current -->
                        <!-- <div class="col-12 mb-3 d-flex d-md-none justify-content-between flex-wrap">
                          <div class="flex-fill text-center">
                            <h6 *ngIf="configType != 'no_part'" class="text-primary">Total Parts</h6>
                            <h6 *ngIf="configType == 'no_part'" class="text-primary">Total Parts</h6>
                            <h5 *ngIf="configType != 'no_part'" class="mb-0">{{ parts ? parts : 0 }}</h5>
                            <h5 *ngIf="configType == 'no_part'" class="mb-0">NA</h5>
                          </div>
                          <div class="flex-fill text-center">
                            <h6 class="text-primary">
                              Current
                              <i style="cursor: pointer" class="ri-wireless-charging-fill font-size-14"></i>
                            </h6>
                            <h5 class="mb-0">{{ current ? current : 0 }}</h5>
                          </div>
                        </div> -->

                        <!-- Desktop View: Total Parts and Current -->
                        <!-- <div class="col-12 col-md-2 d-none d-md-flex flex-column align-items-center">
                          <h6 *ngIf="configType != 'no_part'" class="text-primary">Total Parts</h6>
                          <h5 *ngIf="configType != 'no_part'" class="mb-0">{{ parts ? parts : 0 }}</h5>
                          <h6 *ngIf="configType == 'no_part'" class="text-primary">Total Parts</h6>
                          <h5 *ngIf="configType == 'no_part'" class="mb-0">NA</h5>
                        </div> -->
                        <!-- <div class="col-12 col-md-2 d-none d-md-flex flex-column align-items-center">
                          <h6 class="text-primary">
                            Current(A)
                          </h6>
                          <h5 class="mb-0">{{ current ? current : 0 }}</h5>
                        </div> -->
                         <!-- <div *ngIf="!isMiltiselection" class="col-12 col-md-2 d-none d-md-flex flex-column align-items-center">
                          <h6 class="text-primary">
                           Running Part
                          </h6>
                          <h5 class="mb-0">{{ livepart ? livepart : 'NA' }}</h5>
                        </div>
                      </div> -->

                      <div class="row g-2">

  <!-- M-Efficiency -->
  <div class="col-6 col-md-2 d-flex flex-column align-items-center text-center">
    <h6 class="text-primary mb-1" style="font-size: 11px; white-space: nowrap;">M-Efficiency</h6>
    <h5 class="mb-0">{{ m_effic ? m_effic : 0 }}<span style="font-size: 1rem"> %</span></h5>
  </div>

  <!-- M-Performance -->
  <div class="col-6 col-md-2 d-flex flex-column align-items-center text-center">
    <h6 class="text-primary mb-1" style="font-size: 11px; white-space: nowrap;">M-Performance</h6>
    <h5 class="mb-0">{{ perf ? perf : 0 }}<span style="font-size: 1rem"> %</span></h5>
  </div>

  <!-- Running -->
  <div class="col-6 col-md-2 d-flex flex-column align-items-center text-center">
    <h6 class="text-primary mb-1" style="font-size: 11px; white-space: nowrap;">Running</h6>
    <h5 class="mb-0">{{ convertDuration(pierunning_response) }}</h5>
  </div>

  <!-- Idle -->
  <div class="col-6 col-md-2 d-flex flex-column align-items-center text-center">
    <h6 class="text-primary mb-1" style="font-size: 11px; white-space: nowrap;">Idle</h6>
    <h5 class="mb-0">{{ convertDuration(pieidle_response) }}</h5>
  </div>

  <!-- Total Parts -->
  <div class="col-6 col-md-2 d-flex flex-column align-items-center text-center">
    <h6 class="text-primary mb-1" style="font-size: 11px; white-space: nowrap;">Total Parts</h6>
    <h5 class="mb-0">{{ configType != 'no_part' ? (parts ? parts : 0) : 'NA' }}</h5>
  </div>

  <!-- Running Part -->
  <div *ngIf="!isMiltiselection"
       class="col-6 col-md-2 d-flex flex-column align-items-center text-center"
       style="min-width: 0;">
    <h6 class="text-primary mb-1" style="font-size: 11px; white-space: nowrap;">Running Part</h6>
    <h5 class="mb-0 text-truncate w-100"
        style="font-size: 0.95rem;"
        [title]="livepart || 'NA'">
      {{ livepart ? livepart : 'NA' }}
    </h5>
  </div>

</div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-3" *ngIf="role !== 'SUPERADMIN' && isMiltiselection">
        <div class="card">
          <div class="d-flex justify-content-around align-items-center">
            <p *ngIf="!timerRunning" class="text-truncate text-center mb-1 mt-2">
              <b>Sample Records</b>
            </p>
            <h6 *ngIf="timerRunning" class="text-truncate text-center mb-1 mt-2">
              <b>{{ currentPart }}</b>
            </h6>
            <i *ngIf="configType != 'no_part'" style="cursor: pointer" (click)="openModalsample(sampleTemp)"
              class="ri-file-list-3-fill font-size-13 mt-1"></i>
          </div>

          <div class="form-group" *ngIf="!showfields">
            <div class="d-flex justify-content-around" style="height: 40px">
              <div class="d-flex flex-row">
                <div>
                  StartTime
                  <p *ngIf="timerRunning">{{ startTime }}</p>
                  <p *ngIf="!timerRunning">--:--:--</p>
                </div>
                &nbsp; &nbsp;
                <div>
                  Duration
                  <p *ngIf="timerRunning">{{ caldiff() }}</p>
                  <p *ngIf="!timerRunning">--:--:--</p>
                </div>
              </div>
              <button #candeactivate [disabled]="!isToday || configType == 'no_part'" type="button" class="btn btn-success jobs"
                *ngIf="!timerRunning" (click)="startTimer(); openModaladdrecoard(contentTemp2, 'Add')">
                Start
              </button>
              <button type="button" class="btn btn-danger jobs" *ngIf="timerRunning"
                (click)="openModalrecoard(contentTemp)">
                Stop
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-1">
      <div class="col-md-12 col-xl-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <!-- <div class="col-md-2">
              <div class="form-group">
                <label>Date</label>
                <input type="date" class="form-control" [max]="maxDate" [min]="minDate" [(ngModel)]="startDate"
                  placeholder="From Date" name="startDate" id="startDate" (ngModelChange)="select_Date($event)" />
              </div>
            </div> -->
              <div class="col-md-2">
                <div class="form-group">
                  <label>Shift</label>
                  <select class="form-control custom-select" (ngModelChange)="select_Shift($event)" name="shiftName"
                    id="shiftName" ngModel [(ngModel)]="selectedShifts">
                    <option *ngFor="let el of shiftsArr" [ngValue]="el.usershiftId">
                      {{ el.shiftName }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-2" *ngIf="showPartData && configType != 'no_part'">
                <div class="form-group">
                  <label>Part Name</label>
                  <select class="form-control custom-select" (ngModelChange)="select_Part($event)" name="partName"
                    id="partName" ngModel [(ngModel)]="selectedPart">
                    <option *ngFor="let e of partData" [ngValue]="e.partName">
                      {{ e.partName }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-2" *ngIf="configType != 'no_part'">
                <div>
                  <label>PartProduced</label>
                  <input class="form-control" disabled ngModel [(ngModel)]="selectedPartproduced"
                    (ngModelChange)="checkCount(selectedPartproduced)" />
                </div>
              </div>
              <div class="col-md-2" *ngIf="configType != 'no_part'">
                <div>
                  <label>Part Rejected</label>
                  <input class="form-control" disabled ngModel [(ngModel)]="selectedPartrejected"
                    (ngModelChange)="checkCount(selectedPartrejected)" />
                </div>
              </div>
             <div class="col-md-2" *ngIf="showPartData && configType != 'no_part'">
                <div class="form-group">
                  <div class="d-flex justify-content-between align-items-center">
                    <label for="commentButton" class="form-label">Comments</label>
                    <div class="position-relative" style="cursor: pointer;" (click)="openModalsample(commentViewTemp)">
                      <i class="ri-file-list-3-fill font-size-16"></i>
                      <span 
                        class="badge bg-danger text-white position-absolute"
                        style="top: -6px; right: -10px; padding: 2px 6px; font-size: 10px;"
                        *ngIf="comments.length > 0">
                        {{ comments.length }}
                      </span>
                    </div>
                  </div>
                  <button 
                    (click)="openModaladdsample(commentTemp)"
                    id="commentButton" 
                    class="btn btn-primary w-100"
                    type="button">
                    Add Comment
                  </button>
                  
                </div>
            </div>
            <!-- <div class="col-md-2">
              <p><strong>Comment:</strong> {{ "Hello team, this component has not been implemented correctly." }}</p>
              <p><strong>Time:</strong> {{ "2025-11-18 15:50:55" }}</p>
            </div> -->

            </div>

            <div class="row mt-1">
              <div   [ngClass]="{
                'col-md-6 col-xl-6': configType !== 'no_part',
                'col-md-12 col-xl-12': configType === 'no_part'
              }">
                <div class="card">
                  <div class="card-body">
                    <div class="row d-flex justify-content-between">
                      <div>
                        <h5>Downtime Entry</h5>
                      </div>
                      <div class="d-flex">
                        <select class="form-control custom-select" style="width: 100px" (change)="selectDurations($event)"
                          name="duration" id="duration" ngModel [(ngModel)]="selectDuration">
                          <option value=1 selected>1</option>
                          <option value=5>5</option>
                          <option value=10>10</option>
                          <option value=15>15</option>
                          <option value=20>20</option>
                          <option value=25>25</option>
                          <option value=30>30</option>
                        </select>&nbsp;&nbsp;
                        <input class="form-control" style="width: 100px" placeholder="Search" type="text"
                          autocomplete="off" [(ngModel)]="searchTerm" name="search"
                          id="table-complete-search" />&nbsp;&nbsp;
                        <select class="form-control custom-select" style="width: 100px" (change)="selectType($event)"
                          name="downtimme" id="downtimme" ngModel [(ngModel)]="selectedType">
                          <option *ngFor="let e of downtimeType" [value]="e">
                            {{ e }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="table-responsive mt-1" *ngIf="orderedData.length!=0">
                      <table class="table table-sm table-centered datatable dt-responsive nowrap" style="
                          border-collapse: collapse;
                          border-spacing: 0;
                          width: 100%;
                        ">
                        <thead class="thead-light">
                          <tr>
                            <th>From [HH:MM:SS]</th>
                            <th>To [HH:MM:SS]</th>
                            <th>Status</th>
                            <th>Reason</th>
                            <th>SubReason</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr style="cursor: pointer;" title="Click to give Downtime Reason 👆" (click)="opendowntimeReason(downtimeTemp, item)" *ngFor="
                              let item of orderedData
                                | filter : searchTerm
                                | slice : pageSize2
                                | slice : 0 : itemsPerPage2;
                              let i = index
                            ">
                            <td>
                              {{ item.fromTo.split("-")[0].split(".")[0] }}
                            </td>
                            <td>
                              {{ item.fromTo.split("-")[1].split(".")[0] }}
                            </td>
                            <td>{{item.name}}</td>
                            <td>{{ item.reasonData["reason"] }}</td>
                            <td>{{ item.reasonData["subReason"] }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <div>
                        <ngb-pagination class="pagination-rounded page2" [collectionSize]="orderedData?.length"
                          #numPages2 [pageSize]="itemsPerPage2" [(page)]="currentPage2" [maxSize]="1" [rotate]="true"
                          [ellipses]="false" [boundaryLinks]="true" (pageChange)="onPageChange2(currentPage2)">
                        </ngb-pagination>
                      </div>
                    </div>
                    <div style="height: 100px;display: flex; justify-content: center;align-items: center;"  *ngIf="orderedData.length==0">
                      No Downtime for this Machine !!!
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6 col-xl-6" *ngIf="configType != 'no_part'">
                <div class="card">
                  <div class="card-body">
                    <div class="row d-flex justify-content-between align-items-center" *ngIf="configType != 'no_part'">
                      <!-- Title -->
                      <div class="head">
                        <h5>Rejection Entry</h5>
                      </div>

                      <div class="d-flex">
                        <!-- Mode Selection -->
                        <select class="form-control custom-select" (change)="selectChoice($event)">
                          <option value="single">Single</option>
                          <option value="multiple">Multiple</option>
                        </select>&nbsp;&nbsp;
                        <input class="form-control" style="width: 100px" placeholder="Search" type="text"
                          autocomplete="off" [(ngModel)]="searchTerm2" (input)="filterData()" name="search"
                          id="table-complete-search" />&nbsp;&nbsp;
                          <select
                            class="form-control"
                            style="width: auto; min-width: 120px;"
                            [(ngModel)]="selectedStatus"
                            (change)="filterData()">
                            <option value="all">All</option>
                            <option value="pass">Pass</option>
                            <option value="reject">Reject</option>
                          </select>&nbsp;&nbsp;
                        <select class="form-control custom-select" [(ngModel)]="selectedHour" (ngModelChange)="selectHour($event)">
                          <option value="">All Hour</option>
                          <option [value]="val.hour" *ngFor="let val of hours">{{val.hour}}</option>
                        </select>
                      </div>
                      <!-- Search Input -->
                      <div class="mt-1">
                        <input *ngIf="!singlebool" type="number" id="count" name="count" class="form-control ml-2"
                          style="width: 100px" [(ngModel)]="searchCount" (input)="getCount()" placeholder="Count" />
                      </div>


                    </div>

                    <!-- Table Section -->
                    <div class="table-responsive mt-1" *ngIf="filteredData.length!=0 && configType != 'no_part'">
                      <table class="table table-sm table-centered datatable dt-responsive nowrap"
                        style="border-collapse: collapse; border-spacing: 0; width: 100%;">
                        <thead class="thead-light">
                          <tr>
                            <th *ngIf="!singlebool">Select</th>
                            <th>Part ID</th>
                            <th>Reason</th>
                            <th>Rejected</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            *ngFor="let item of filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage); let i = index">
                            <td *ngIf="!singlebool">
                              <input type="checkbox" [checked]="item.flag" (change)="toggleFlag(item)" />
                            </td>
                            <td>{{ partcountType=='edge'? item._id: item.partId}}</td>
                            <td>
                              <select class="reject" (change)="onReason(item)" [disabled]="!singlebool"
                                name="rejectReason" id="rejectReason" [(ngModel)]="item.Reason">
                                <option value="" selected>Select Reason</option>
                                <option *ngFor="let data of rejectionReasons" [value]="data.reason">
                                  {{ data.reason }}
                                </option>
                              </select>
                            </td>
                            <td>
                              <span [ngClass]="item.isRejected ? 'badge badge-danger' : 'badge badge-success'">
                                {{ item.isRejected ? "Rejected" : "Pass" }}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <!-- Pagination and Submit Button -->
                      <div class="d-flex justify-content-between align-items-center mt-2">
                        <ngb-pagination class="pagination-rounded" [collectionSize]="filteredData?.length"
                          [pageSize]="itemsPerPage" [(page)]="currentPage" [maxSize]="1" [rotate]="true"
                          [ellipses]="false" [boundaryLinks]="true" (pageChange)="onPageChange($event)">
                        </ngb-pagination>

                        <button class="btn btn-primary" *ngIf="!singlebool" type="button"
                          (click)="openrejectionReason(rejectionTemp)">
                          Submit
                        </button>
                      </div>
                    </div>
                    <div style="height: 100px;display: flex; justify-content: center;align-items: center;" *ngIf="filteredData.length==0 || configType == 'no_part'">
                      No Part is produced for this Machine !!!
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="showCombined">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <h4 class="card-title">Live Gantt Chart</h4>
              </div>
              <div class="col-md-6 text-md-right">
                <div class="d-inline-block mr-2">
                  <p class="badge" style="background-color: #f7c030; color: white">
                    Idle
                  </p>
                </div>
                <div class="d-inline-block mr-2">
                  <p class="badge" style="background-color: #ffff94">Dryrun</p>
                </div>
                <div class="d-inline-block mr-2">
                  <p class="badge" style="background-color: #548237; color: white">
                    Running
                  </p>
                </div>
                <div class="d-inline-block mr-2" (click)="LiveChart(params)" *ngIf="!intervalFlag">
                  <p class="badge">
                    <i class="ri-refresh-line align-middle mr-2"></i>Refresh
                  </p>
                </div>

                <div class="d-inline-block mr-2">
                  <p class="badge" style="background-color: white; color: black">
                    No Data
                  </p>
                </div>
              </div>
            </div>
            <app-combinechart *ngIf="showChart" [gaugeArray]="finalcombinedData"></app-combinechart>

            <div *ngIf="!showChart">
              <img src="assets/images/noData.jpg" width="100%" />
              Please wait we are fetching data / nodata
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" [hidden]="ganttBool">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <h4 class="card-title">
                  <select [(ngModel)]="selectedDateOption" (change)="historyChart()">
                    <option value="Live">Today</option>
                    <option *ngFor="let data of previousDays" [value]="data">
                      {{ data }}
                    </option>
                  </select>
                  Gantt Chart
                </h4>
              </div>

              <div class="col-md-6 text-md-right">
                <div class="d-inline-block mr-2">
                  <p class="badge" style="background-color: #f7c030; color: white">
                    Idle
                  </p>
                </div>

                <div class="d-inline-block mr-2">
                  <p class="badge" style="background-color: #548237; color: white">
                    Running
                  </p>
                </div>
                <div class="d-inline-block mr-2" *ngIf="intervalFlag" (click)="LiveChart(params)">
                  <p class="badge" style="background-color: #375e82; color: white">
                    <i class="ri-refresh-line align-middle mr-2"></i> Refresh
                  </p>
                </div>
              </div>
            </div>

            <app-newganttchart *ngIf="showChart" [gaugeArray]="historyDatas"></app-newganttchart>
          </div>
          <div *ngIf="!showChart">
            <img src="assets/images/noData.jpg" width="100%" />
            Please wait we are fetching data / nodata
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="mt-3 d-flex justify-content-center align-items-center text-center" *ngIf="!showData">
  Machines are not planned on this Day. To view data, Map the operator to the
  Machine.
</div>

<ng-template #currenttemplate role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Current Trend</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="row">
      <div class="col-md-12">
        <app-energychart [gaugeArray]="finalcombinedData"></app-energychart>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #sampleTemp role="document" let-modal="close">
  <div class="modal-header">
    <div class="d-flex justify-content-center align-items-center">
      <h5 class="modal-title">Records</h5>
      &nbsp;&nbsp;
      <input class="form-control search__input" placeholder="Search" type="text" autocomplete="off"
        [(ngModel)]="searchRecord" (input)="filterSampleData()" name="searchRecord" id="searchRecord" />
    </div>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <!-- <div class="col-md-6"> -->
    <!-- <div class="card">
          <div class="card-body"> -->
    <div class="table-responsive" *ngIf="filteredsampleData?.length != 0">
      <table class="table table-centered datatable dt-responsive nowrap"
        style="border-collapse: collapse; border-spacing: 0; width: 100%">
        <thead class="thead-light">
          <tr>
            <th>Part Name</th>
            <th>Form-To [HH:MM:SS]</th>
            <th>Duration [HH:MM:SS]</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="
              let data of filteredsampleData
                | slice : pageSize1
                | slice : 0 : itemsPerPage1;
              let i = index
            ">
            <td>{{ data.program }}</td>
            <td>
              {{ formatTime(data.startTime) }}-{{ formatTime(data.endTime) }}
            </td>
            <td>{{ data.duration }}</td>
          </tr>
        </tbody>
      </table>
      <div class="col-md-12" style="display: flex; justify-content: space-between">
        <div>
          <ngb-pagination class="pagination-rounded page" [collectionSize]="filteredsampleData?.length" #numPages1
            [pageSize]="itemsPerPage1" [(page)]="currentPage1" [maxSize]="1" [rotate]="true" [ellipses]="false"
            [boundaryLinks]="true" (pageChange)="onPageChange1(currentPage1)">
          </ngb-pagination>
        </div>
      </div>
    </div>
    <div *ngIf="filteredsampleData?.length == 0" class="text-center">
      <img src="assets/images/noData.jpg" class="imgs" />
      Please wait we are fetching data / nodata
    </div>
    <!-- </div>
        </div> -->
    <!-- </div> -->
  </div>
</ng-template>
<ng-template #shifttemplate role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Shift Details</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="media">
              <div class="media-body overflow-hidden">
                <div class="row">
                  <div class="col-md-3 text-center" *ngFor="let shift of shiftsArr">
                    <div [ngClass]="{
                        'current-shift':
                          currentShift &&
                          currentShift.shiftName === shift.shiftName
                      }">
                      <p>{{ shift.shiftName }}</p>
                      <h4>{{ shift.startTime }} - {{ shift.endTime }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #contentTemp role="document" let-modal="close">
  <form (ngSubmit)="saveDatas()" [formGroup]="validationform" autocomplete="off">
    <div class="container">
      <div class="modal-header">
        <h5 class="modal-title">Sample Recard</h5>
        <button type="button" [disabled]="!addRecord" class="close" aria-label="Close" (click)="modal('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-3">
        <!-- <div class="row d-flex justify-content-center"> -->
        <!-- <div class="col-md-6"> -->
        <!-- <div class="card">
              <div class="card-body"> -->
        <div class="form-group">
          <label for="program">Are you sure, need to end this Production !!!</label>
        </div>
        <div class="text-right">
          <button type="button" class="btn btn-success" (click)="stopTimer()">
            Submit
          </button>
          &nbsp;
          <button type="button" class="btn btn-secondary" (click)="modal('Cross click')">
            Cancel
          </button>
          <!-- </div> -->
          <!-- </div>
            </div> -->
          <!-- </div> -->
        </div>
      </div>
    </div>
  </form>
</ng-template>
<ng-template #contentTemp2 role="document" let-modal="close">
  <form (ngSubmit)="saveDatas()" [formGroup]="validationform" autocomplete="off">
    <div class="container">
      <div class="modal-header">
        <h5 class="modal-title">Sample Recard</h5>
        <button type="button" [disabled]="!addRecord" class="close" aria-label="Close" (click)="modal('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-3">
        <div class="d-flex justify-content-between">
          <div class="form-group col-md-6">
            <label for="program">Program Name</label>

            <select class="form-control" id="program" formControlName="program" [ngClass]="{
                'is-invalid': submitted && form.program.errors
              }" (change)="getSelectedPart($event.target.value)">
              <option value="" disabled selected>Select a Part</option>
              <option *ngFor="let part of partData" [value]="part.partName">
                {{ part.partName }}
              </option>
            </select>
            <div *ngIf="submitted && form.program.errors" class="invalid-feedback">
              <span *ngIf="form.program.errors.required">Program Name is mandatory.</span>
            </div>
          </div>
        </div>
        <div class="text-right">
          <button type="button" class="btn btn-success" (click)="saveDatas()">
            Submit
          </button>
          &nbsp;
          <button type="button" class="btn btn-secondary" (click)="close1(); modal('Cross click')">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </form>
</ng-template>
<ng-template #rejectionTemp role="document" let-modal="close">
  <div class="modal-header">
    <div>
      <h5 class="modal-title">Rejection</h5>
      &nbsp;&nbsp;
    </div>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="d-flex justify-content-between">
      <div class="form-group col-md-6">
        <label for="rejectReason2">Select Reason</label>
        <select class="form-control" (change)="onReason2($event)" name="rejectReason2" id="rejectReason2"
          [(ngModel)]="selectedRejection">
          <option value="" disabled selected>Select Reason</option>
          <option *ngFor="let data of rejectionReasons" [value]="data.reason">
            {{ data.reason }}
          </option>
        </select>
      </div>
      <div class="form-group col-md-6 d-flex justify-content-center align-items-center">
        <div>
          <button class="btn btn-primary" type="submit" (click)="multiReason()">
            Save
          </button>
        </div>
        &nbsp;
        <button type="button" class="btn btn-secondary" (click)="multiReasonclose(); modal('Cross click')">
          Cancel
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #downtimeTemp role="document" let-modal="close">
  <div class="modal-header">
    <div>
      <h5 class="modal-title">Downtime</h5>
      &nbsp;&nbsp;
    </div>
    <button type="button" class="close" aria-label="Close" (click)="multidownclose(); modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="d-flex justify-content-between">
      <div class="row justify-content-start">
        From - To : {{ downtimeData["fromTo"].split("-")[0].split(".")[0] }} -
        {{ downtimeData["fromTo"].split("-")[1].split(".")[0] }}
      </div>
      <div class="row justify-content-end" (click)="AddSubReason()">
        <i *ngIf="addBool" [hidden]="isSame" class="mdi mdi-plus-circle mr-2" style="color: '#1bcfb4'"></i>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="table-responsive col-md-12">
          <table class="table table-md datatable dt-responsive nowrap" style="
              border-collapse: collapse;
              border-spacing: 0;
              width: 100%;
              max-width: fit-content;
            ">
            <thead class="bold-header">
              <tr>
                <th *ngIf="!isSame" class="col-start-time">StartTime</th>
                <th *ngIf="!isSame" class="col-end-time">EndTime</th>
                <th class="col-reason">Reason</th>
                <th class="col-subreason">SubReason</th>
                <th *ngIf="!isSame" class="col-action">Action</th>
              </tr>
            </thead>
            <tbody *ngIf="downtimevalues.length > 0">
              <tr *ngFor="let data of downtimevalues; let i = index">
                <td *ngIf="!isSame">
                  <input type="text" class="form-control form-control-sm" name="startTime{{ i }}" disabled
                    id="startTime{{ i }}" ngModel [(ngModel)]="data.startTime" />
                </td>
                <td *ngIf="!isSame">
                  <select name="endTime{{ i }}" id="endTime{{ i }}" class="form-control form-control-sm" ngModel
                    [(ngModel)]="data.endTime" (change)="changeTime($event, i)"
                    [disabled]="i !== downtimevalues.length - 1">
                    <option value="" disabled selected>Select End Time</option>
                    <!-- <option *ngFor="let val of endtimeData" [value]="val">{{ val }}</option> -->
                    <option *ngFor="let val of endtimeData[i]" [value]="val">
                      {{ val }}
                    </option>
                  </select>
                </td>
                <td *ngIf="!isSame">
                  <select name="mainReason{{ i }}" id="mainReason{{ i }}" class="form-control form-control-sm" ngModel
                    [(ngModel)]="data.reason" (change)="changeReason($event.target.value, i,'ui')"
                    [disabled]="i !== downtimevalues.length - 1 || timeBool">
                    <option value="" disabled selected>Select Reason</option>
                    <option *ngFor="let reason of downtimeReasons" [value]="reason['reason']">
                      {{ reason["reason"] }}
                    </option>
                  </select>
                </td>
                <td *ngIf="isSame">
                  <select name="mainReason{{ i }}" id="mainReason{{ i }}" class="form-control form-control-sm" ngModel
                    [(ngModel)]="data.reason" (change)="changeReason($event.target.value, i,'ui')">
                    <option value="" disabled selected>Select Reason</option>
                    <option *ngFor="let reason of downtimeReasons" [value]="reason['reason']">
                      {{ reason["reason"] }}
                    </option>
                  </select>
                </td>
                <td *ngIf="!isSame">
                  <select name="subreason{{ i }}" id="subreason{{ i }}" class="form-control form-control-sm" ngModel
                    [(ngModel)]="data.subReason" (change)="changesubReason($event, i)"
                    [disabled]="i !== downtimevalues.length - 1 || timeBool">
                    <option value="" disabled selected>
                      Select Sub-Reason
                    </option>
                    <option *ngFor="let subreason of subReasonData[i]" [value]="subreason['subReason']">
                      {{ subreason["subReason"] }}
                    </option>
                  </select>
                </td>
                <td *ngIf="isSame">
                  <select name="subreason{{ i }}" id="subreason{{ i }}" class="form-control form-control-sm" ngModel
                    [(ngModel)]="data.subReason" (change)="changesubReason($event, i)">
                    <option value="" disabled selected>
                      Select Sub-Reason
                    </option>
                    <option *ngFor="let subreason of subReasonData[i]" [value]="subreason['subReason']">
                      {{ subreason["subReason"] }}
                    </option>
                  </select>
                </td>
                <td *ngIf="!isSame" class="text-center align-middle">
                  <i *ngIf="i === downtimevalues.length - 1 && downtimevalues.length !== 1" class="mdi mdi-minus-circle mr-1 text-danger"
                    (click)="removeRow(i)" style="cursor: pointer"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="form-group col-md-12 d-flex justify-content-center align-items-center">
      <div *ngIf="!isSame">
        <button class="btn btn-primary" [disabled]="timeBool" type="submit" (click)="multidownReason()">
          Save
        </button>
      </div>
      &nbsp;
      <div *ngIf="isSame">
        <button class="btn btn-primary" type="submit" (click)="multidownReason()">
          Save
        </button>
      </div>
      &nbsp;
      <button type="button" class="btn btn-secondary" (click)="multidownclose(); modal('Cross click')">
        Cancel
      </button>
    </div>
  </div>
</ng-template>
<ng-template #commentTemp role="document" let-modal="close">
  <div class="modal-header">
    <div class="d-flex justify-content-center align-items-center">
      <h5 class="modal-title">Comments</h5>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="commentclose();modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body p-3">
    <textarea 
      class="form-control w-100" 
      rows="3" 
      [(ngModel)]="commentText"
      placeholder="Enter comments">
    </textarea>
  </div>

  <div class="modal-footer d-flex justify-content-center">
    <button 
      type="button" 
      class="btn btn-secondary px-4"
      (click)="commentclose();modal('Cross click')">
      Cancel
    </button>

    <button 
      type="button" 
      class="btn btn-primary px-4"
      (click)="saveComment()">
      Save
    </button>
  </div>
</ng-template>

<ng-template #commentViewTemp role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Comments</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body p-3">

    <div *ngIf="comments.length === 0" class="text-center text-muted">
      No comments added.
    </div>

    <div *ngFor="let c of comments
                | slice : constentSize
                | slice : 0 : commentsPerPage;
       let i = index" class="border rounded p-2 mb-2">
      <div class="d-flex justify-content-between">
        <div class="text-dark">{{ c['commentText'] }}</div>

        <div>
          <i class="ri-edit-2-line text-primary mr-2"
             style="cursor:pointer"
             (click)="editComment(c); openModalsample(commentTemp)">
          </i>

          <i class="ri-delete-bin-line text-danger"
             style="cursor:pointer"
             (click)="deleteComment(c['id'])">
          </i>
        </div>
      </div>
    </div>
    <div>
  <ngb-pagination class="pagination-rounded page2" [collectionSize]="comments?.length"
    #numPages2 [pageSize]="commentsPerPage" [(page)]="commentcurrentPage" [maxSize]="1" [rotate]="true"
    [ellipses]="false" [boundaryLinks]="true" (pageChange)="onPagecontentChange(commentcurrentPage)">
  </ngb-pagination>
  </div>                      

  </div>
</ng-template>
<ng-template #interlock let-modal="close">
  <!-- Modal Header -->
  <div class="modal-header py-2 px-3">
    <h6 class="modal-title fw-bold mb-0">⚡ Interlock Monitor</h6>
     <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <!-- Modal Body -->
  <div class="modal-body bg-light p-3">
    <div class="row g-2 align-items-stretch">
      <div class="col-md-4 d-flex" *ngFor="let item of interlockData; let i = index">

        <div class="card shadow-sm w-100" [ngClass]="item.interlockReason === 1 ? 'border-success' : 'border-warning'"
          style="border-width:2px !important; border-radius:10px;">

          <!-- Card Header -->
          <div class="card-header d-flex justify-content-between align-items-center px-2 py-1"
            [ngClass]="item.interlockReason === 1 ? 'bg-success bg-opacity-10 border-bottom border-success' : 'bg-warning bg-opacity-10 border-bottom border-warning'"
            style="border-radius:8px 8px 0 0;">
            <span class="badge fw-bolder" style="font-size:0.85rem; letter-spacing:0.5px;"
              [ngClass]="item.interlockReason === 1 ? 'bg-success text-white' : 'bg-warning text-dark'">
              {{ item.parameter }}
            </span>
          </div>

          <!-- Card Body -->
          <div class="card-body px-2 py-2 flex-grow-1">

            <!-- Timestamp -->
            <div class="bg-white rounded px-2 py-1 mb-2 border" style="font-size:0.75rem;">
              <span class="fw-bolder text-dark">🕒 {{ item.start_ts | date:'medium' }}</span>
            </div>

            <!-- Reason -->
            <div class="mb-1">
              <label class="text-uppercase fw-bold mb-1 d-block" style="font-size:0.62rem; letter-spacing:0.8px;"
                [ngClass]="item.interlockReason === 1 ? 'text-success' : 'text-warning'">
                Reason
              </label>
              <select class="form-select form-select-sm py-1" style="font-size:0.72rem;"
                [ngClass]="item.interlockReason === 1 ? 'border-success' : 'border-warning'"
                [(ngModel)]="item.reasonCode" (ngModelChange)="getChangeReason($event, item)">
                <option value="" disabled>— Select Reason —</option>
                <option *ngFor="let reason of downtimeReasons2" [value]="reason['reasonCode']">
                  {{ reason["reason"] }}
                </option>
              </select>
            </div>

            <!-- Sub Reason -->
            <div class="mb-1" *ngIf="item.subreasonData && item.subreasonData.length > 0">
              <label class="text-uppercase fw-bold mb-1 d-block" style="font-size:0.62rem; letter-spacing:0.8px;"
                [ngClass]="item.interlockReason === 1 ? 'text-success' : 'text-warning'">
                Sub Reason
              </label>
              <select class="form-select form-select-sm py-1" style="font-size:0.72rem;"
                [ngClass]="item.interlockReason === 1 ? 'border-success' : 'border-warning'"
                [(ngModel)]="item.subReasonCode">
                <option value="" disabled>— Select Sub Reason —</option>
                <option *ngFor="let reason of item.subreasonData" [value]="reason['subReasonCode']">
                  {{ reason["subReason"] }}
                </option>
              </select>
            </div>

          </div>

          <!-- Card Footer -->

          <div class="card-footer bg-white d-flex justify-content-end align-items-center px-2 py-1"
            [ngClass]="item.interlockReason === 1 ? 'border-top border-success' : 'border-top border-warning'"
            style="border-radius:0 0 8px 8px;">
            <button class="btn btn-sm px-3 fw-semibold" style="font-size:0.72rem;"
              [ngClass]="item.interlockReason === 1 ? 'btn-success' : 'btn-warning'" [disabled]="item.isPending"
              (click)="submitInterlock(item)">
              <span *ngIf="item.isPending" class="spinner-border spinner-border-sm me-1" role="status"></span>
              {{ item.isPending ? 'Waiting...' : 'Submit' }}
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</ng-template>
